import { render, staticRenderFns } from "./ProductNutritionExtended.vue?vue&type=template&id=1615153d&"
import script from "./ProductNutritionExtended.vue?vue&type=script&lang=js&"
export * from "./ProductNutritionExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports